import React from 'react';
import cx from 'classnames';

function RecaptchaText({classes, children}) {
  return (
    <p className={cx('leading-snug recaptcha-text', classes)}>
      {children}
      This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.
    </p>
  );
}

export default RecaptchaText;
